import React from 'react';

const AboutSection = () => {
    return (
        <section className="about-section">
            <h1>Who We Are</h1>
            <p>
                At NIRVS.AI, we merge artificial intelligence with cinematic artistry. Our goal is to empower creators, brands, and storytellers to craft visionary content faster and smarter using state-of-the-art AI tools.
            </p>
        </section>
    );
};

export default AboutSection;
